import { Box } from '@mui/material'

import { CustomTooltip } from 'components/shared/CustomTooltip'

interface Props {
  label: string
  value: string
  tooltip: string
}

export default function AgentInfoBox(props: Props) {
  const { label, value, tooltip } = props

  return (
    <>
      {tooltip ? (
        <CustomTooltip title={tooltip}>
          <Box
            sx={{
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 700,
              fontSize: '16px',
              lineHeight: '21px',
            }}
          >
            {value}
          </Box>
        </CustomTooltip>
      ) : (
        <Box
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '21px',
          }}
        >
          {value}
        </Box>
      )}
      <Box
        fontSize={14}
        sx={{
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: 700,
          fontSize: '12px',
          lineHeight: '16px',
          color: '#6F6F70',
        }}
      >
        {label}
      </Box>
    </>
  )
}
